import React from "react";

export const APMPost = ({title, sections}) => {

    return (
        <div className="flex flex-col items-center justify-center">
            <div className="text-center text-[32px] xl:text-[44px] font-extrabold font-['Open Sans'] bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text  xl:w-[1369px] my-[60px] xl:mt-[120px]">
                {title}
            </div>

            <div className="flex flex-col items-center justify-center xl:w-[1170px]">
                {sections.map((section, key) => {
                    return (
                    <div className="text-center mb-[20px]" key={`apm-section-${key}`}>
                        <div className="text-[20px]">
                        {section.title}
                    </div>
                    <div className="text-[20px]">
                        {section.content}
                        </div>
                    </div>
                    )
                })}
            </div>
        </div>
    )
}